import { IForm } from '@/components/types'
import { getBeforeDate } from '@/utils/utils'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'corpId',
      type: 'select',
      label: '企业',
      clearable: true,
      placeholder: '请选择企业',
      filterable: true,
      options: []
    },
    {
      field: 'groupName',
      type: 'select',
      label: '组',
      placeholder: '请选择组',
      filterable: true,
      clearable: true,
      options: []
    },
    {
      field: 'deptName',
      type: 'select',
      label: '岗位',
      clearable: true,
      placeholder: '请选择岗位',
      filterable: true,
      options: [
        { title: '全部', value: '' },
        { title: '518', value: '518' },
        { title: '投教', value: '投教' }
      ]
    },
    {
      label: '账户ID',
      field: 'userId',
      clearable: true,
      type: 'input',
      placeholder: '请输入账户ID'
    },
    {
      label: '名称',
      field: 'name',
      clearable: true,
      type: 'input',
      placeholder: '请输入名称'
    },
    {
      label: '使用人',
      field: 'usedBy',
      type: 'select',
      filterable: true,
      clearable: true,
      placeholder: '请选择使用人'
    },
    {
      field: 'duration',
      type: 'select',
      label: '单次时长',
      placeholder: '请选择单次时长',
      options: [
        { title: '不限', value: 0 },
        { title: '>1分钟', value: 1.000001 },
        { title: '>2分钟', value: 2.000001 },
        { title: '≥5分钟', value: 5 },
        { title: '≥10分钟', value: 10 },
        { title: '≥15分钟', value: 15 },
        { title: '≥20分钟', value: 20 }
      ]
    },
    {
      field: 'callCounts',
      type: 'select',
      label: '通话量',
      placeholder: '请选择通话量',
      options: [
        { title: '不限', value: 0 },
        { title: '>10次', value: 10 },
        { title: '>20次', value: 20 },
        { title: '≥30次', value: 30 },
        { title: '≥50次', value: 50 },
        { title: '≥100次', value: 100 }
      ]
    },
    {
      field: 'callDate',
      type: 'datepicker',
      label: '通话日期',
      clearable: false,
      otherOptions: {
        ctlField: 'callTime',
        check(value: any) {
          return value[0] != value[1]
        },
        startPlaceholder: '开始日期',
        endPlaceholder: '结束日期',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
    {
      field: 'callTime',
      type: 'timePicker',
      label: '时间范围',
      clearable: false,
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        valueFormat: 'HH',
        start: '00:00:00',
        end: '23:59:00',
        step: '01:00:00',
        disabled: true
      }
    },
    {
      field: 'timeRange',
      type: 'select',
      label: '时间段',
      placeholder: '请选择时间段',
      change(value: any) {
        return [getBeforeDate(value), getBeforeDate('today')]
      },
      descField: 'callDate',
      options: [
        { title: '今天', value: 'today' },
        { title: '近7天', value: '7_days' },
        { title: '近1个月', value: '1_month' },
        { title: '近3个月', value: '3_months' },
        { title: '近6个月', value: '6_months' },
        { title: '近1年', value: '1_year' },
        { title: '所有', value: 'all' }
      ],
      otherOptions: {
        ctlField: 'callTime',
        check(value: any) {
          return value != 'today'
        }
      }
    }
  ]
}
